mutation TimelineEventDelete($input: TimelineEventDeleteInput!) {
    timelineEventDelete(input: $input) {
        eventId
    }
}
